import { useEffect } from 'react';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import ServicesGrid from './components/ServicesGrid';
import Process from './components/Process';
import CTA from './components/CTA';
import Footer from '../home/components/Footer';
import { useSchemaOrg } from '../../utils/seo';

export default function AutomationAIIntegrations() {
  // Add WebPage Schema
  useSchemaOrg({
    type: 'WebPage',
    data: {
      name: 'Automation & AI Integrations - Yepes WebLab',
      description: 'Transform your business with intelligent automation and AI integration solutions. Streamline workflows and boost productivity.',
      url: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/automation-ai-integrations`,
    },
  });

  // Add Service Schema for Automation & AI
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    
    const serviceSchema = {
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      itemListElement: [
        {
          '@type': 'Service',
          position: 1,
          name: 'Workflow Automation',
          description: 'Automate repetitive tasks and streamline your business processes for maximum efficiency.',
          provider: {
            '@type': 'Organization',
            name: 'Yepes WebLab',
            url: siteUrl,
          },
          areaServed: 'Worldwide',
        },
        {
          '@type': 'Service',
          position: 2,
          name: 'AI Integration',
          description: 'Integrate cutting-edge AI solutions into your existing systems to enhance capabilities.',
          provider: {
            '@type': 'Organization',
            name: 'Yepes WebLab',
            url: siteUrl,
          },
          areaServed: 'Worldwide',
        },
        {
          '@type': 'Service',
          position: 3,
          name: 'Custom Bots',
          description: 'Intelligent chatbots and automation bots tailored to your specific business needs.',
          provider: {
            '@type': 'Organization',
            name: 'Yepes WebLab',
            url: siteUrl,
          },
          areaServed: 'Worldwide',
        },
        {
          '@type': 'Service',
          position: 4,
          name: 'API Automation',
          description: 'Seamless API integrations that connect your tools and automate data flow.',
          provider: {
            '@type': 'Organization',
            name: 'Yepes WebLab',
            url: siteUrl,
          },
          areaServed: 'Worldwide',
        },
        {
          '@type': 'Service',
          position: 5,
          name: 'Data Processing',
          description: 'Automated data collection, processing, and analysis to drive informed decisions.',
          provider: {
            '@type': 'Organization',
            name: 'Yepes WebLab',
            url: siteUrl,
          },
          areaServed: 'Worldwide',
        },
        {
          '@type': 'Service',
          position: 6,
          name: 'Smart Integrations',
          description: 'Connect your favorite tools and platforms with intelligent automation solutions.',
          provider: {
            '@type': 'Organization',
            name: 'Yepes WebLab',
            url: siteUrl,
          },
          areaServed: 'Worldwide',
        },
      ],
    };

    const scriptId = 'schema-automation-services';
    let scriptTag = document.getElementById(scriptId);

    if (!scriptTag) {
      scriptTag = document.createElement('script');
      scriptTag.id = scriptId;
      scriptTag.type = 'application/ld+json';
      document.head.appendChild(scriptTag);
    }

    scriptTag.textContent = JSON.stringify(serviceSchema);

    return () => {
      const existingScript = document.getElementById(scriptId);
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <Hero />
      <ServicesGrid />
      <Process />
      <CTA />
      <Footer />
    </div>
  );
}
